export const environment = {
  production: false,
  apiUrl: 'https://braidsbook.cleverapps.io/api/admin',
  baseUrl: 'https://braidsbook.cleverapps.io'
};